import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getMultiLineSnackBarProps } from '../../../store/global/selectors';
import { handleMultiLineSnackBar } from '../../../store/global/actions';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  snackBar: {
    zIndex: 1502,
    marginTop: 55
  }
}));

export default function MultiLineSnackbar() {
  const dispatch = useDispatch();
  const classes = useStyles();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(handleMultiLineSnackBar({}, true));
  };

  const { message, severity, ...rest } = useSelector(getMultiLineSnackBarProps);
  
  return (
    <div className={classes.root}>
      <Snackbar {...rest} onClose={handleClose} className={classes.snackBar} key={message}>
        {rest.open && (
          <Alert onClose={handleClose} severity={severity} style={{alignItems: 'center'}}>
            <Typography variant="body1" whiteSpace="pre-line">
              {message.split('\n').map((line, index) => (
                <React.Fragment key={index}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </Typography>
          </Alert>
        )}
      </Snackbar>
    </div>
  );
}

